module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAwElEQVQoU3WQMQrCQBREZw1iIyzoETS1zVQhTTyAeA0FD6AX0NrKUygewMYuZPcKVhb2CxqjsBLIhhjjbwbmP/4fRqAYpdQNwJ7k3HlVFRVwAWALYENyWYdLMF8opaYADgDWJFeNF52ZJMlECHGsw18XHay1HltrTwB2JGe53wgWMV65kmz/BYsG7mmajsIwND+gtbaltb4CkFLKnu/7TxenfB3Hcd/zvAuAjjGmG0XR+1+PZwDDLMsGQRA86j1+AFLnQQsb/LIeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-m.png
// module id = FZyP
// module chunks = 1